import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Tracking = () => {
  const location = useLocation();

  useEffect(() => {   
    if (typeof dataLayer === 'undefined') {
      return;
    }
    
    // ignore pdf generation
    if (location.pathname.toLowerCase() === '/pdf') {
      return;
    }

    dataLayer.push({
        event: 'configurator_page',
        page: location.pathname
    });

    // emit additional event when configurator is finished
    if (location.pathname.toLowerCase() === '/simulationresult') {
      dataLayer.push({
        event: 'configurator_finish'        
      });
    }

  }, [location]);

  return null;
};

export default Tracking;
